import HTMLGenerator from '@intercom/embercom-composer/lib/html-generator';
import $ from 'jquery';
const HtmlBlockStyleTransformer = function () {};
HtmlBlockStyleTransformer.process = function (blocks, styleTransformer) {
  if (blocks.length === 0) {
    return;
  }
  let html = getHtml(blocks);
  let htmlWithInlineStyles = styleTransformer.processContent(html);
  updateHtmlBlocksWithInlinedHtml(htmlWithInlineStyles, blocks);
};
function getHtml(blocks) {
  let html = '';
  blocks.forEach(function (block) {
    html += `<div class="ic-block-html">${renderHtmlWithAttributes(block)}</div>`;
  });
  return `<div class="ic-blocks-html">${html}</div>`;
}
function renderHtmlWithAttributes(block) {
  let entities = block.get('entities');
  let text = block.get('text');
  let generator = new HTMLGenerator(text, entities, {
    shouldEscapeContent: false,
    significantWhitespace: false
  });
  return generator.getHtml();
}
function updateHtmlBlocksWithInlinedHtml(htmlWithInlineStyles, blocks) {
  let $inlinedBlocksHtml = $(htmlWithInlineStyles).find('.ic-block-html');
  for (let i = 0, length = blocks.length; i < length; i++) {
    let block = blocks[i];
    block.set('htmlWithInlineStyles', $inlinedBlocksHtml[i].innerHTML);
  }
}
export default HtmlBlockStyleTransformer;